import Vue from "vue";
export const EventBus = new Vue();



//////////////////
// WEBPACK FOOTER
// ./~/vue-bootstrap-toasts/src/event-bus.js
// module id = 493
// module chunks = 0